import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { auth, db } from "../config/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import styles from "../styling/navBar.module.css";

const NavBar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEmployer, setIsEmployer] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "adonis_users", user.uid));
          setIsEmployer(
            userDoc.exists() && userDoc.data().userType === "employer"
          );
        } catch (error) {
          console.error("Error checking user type:", error);
        }
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isMenuOpen]);

  return (
    <nav className={styles["navbar"]}>
      <div className={styles["navbar-left"]}>
        <Link to="/search" className={styles["logo"]}>
          pantheon
        </Link>
      </div>

      <button
        className={`${styles["hamburger"]} ${
          isMenuOpen ? styles["active"] : ""
        }`}
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div
        className={`${styles["navbar-right"]} ${
          isMenuOpen ? styles["show"] : ""
        }`}
      >
        <Link
          to="/search"
          className={`${styles["nav-link"]} ${
            isActive("/search") ? styles["active"] : ""
          }`}
          onClick={closeMenu}
        >
          Search
        </Link>
        <Link
          to="/threads"
          className={`${styles["nav-link"]} ${
            isActive("/threads") ? styles["active"] : ""
          }`}
          onClick={closeMenu}
        >
          Threads
        </Link>
        <Link
          to="/resources"
          className={`${styles["nav-link"]} ${
            isActive("/resources") ? styles["active"] : ""
          }`}
          onClick={closeMenu}
        >
          Resources
        </Link>
        {auth.currentUser ? (
          <Link
            to={isEmployer ? "/employer-profile" : "/profile"}
            className={`${styles["nav-link"]} ${
              isActive("/profile") || isActive("/employer-profile")
                ? styles["active"]
                : ""
            }`}
            onClick={closeMenu}
          >
            Profile
          </Link>
        ) : (
          <Link
            to={""}
            className={`${styles["nav-link"]} ${
              isActive("/profile") || isActive("/employer-profile")
                ? styles["active"]
                : ""
            }`}
            onClick={() => {
              closeMenu();
              window.location.href = "/";
            }}
          >
            Profile
          </Link>
        )}
        {/* <a
          href="https://x.com/abdulmendahawi"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["nav-link"]}
          onClick={closeMenu}
        >
          Twitter
        </a> */}
      </div>

      {isMenuOpen && (
        <div
          className={styles["overlay"]}
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </nav>
  );
};

export default NavBar;
